import { Search } from 'lucide-react';
import { useMenuLabels } from '../../hooks/useMenuLabels';

interface GroupsHeaderProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export default function GroupsHeader({ searchTerm, onSearchChange }: GroupsHeaderProps) {
  const labels = useMenuLabels();

  return (
    <section className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
      <div className="min-w-0">
        <p className="mb-0 max-w-2xl text-sm leading-6 text-gray-600 sm:text-base">
          Browse and join communities, {labels.list}, and collaboration teams.
        </p>
      </div>

      <div className="flex w-full flex-col gap-3 sm:flex-row lg:w-auto">
        <div className="relative w-full sm:min-w-[300px] lg:w-[340px]">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
          <input
            type="search"
            value={searchTerm}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder={`Search ${labels.list} by name...`}
            className="h-11 w-full rounded-lg border border-gray-200 bg-white py-2 pl-10 pr-4 text-sm text-gray-900 shadow-sm transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
            aria-label={`Search ${labels.list} by name`}
          />
        </div>
      </div>
    </section>
  );
}
